import { GetVehicleBrandsResponse } from "@/app/api/vehicle-brands/route";
import { getVehicleBrandsRequestSchema } from "@/lib/schemas/vehicle-brands";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const VEHICLE_BRANDS_ENDPOINT = "/api/vehicle-brands";

export const invalidateVehicleBrandsQuery = createInvalidateQuery(
  VEHICLE_BRANDS_ENDPOINT,
);

export const useVehicleBrandsQuery = createQueryHook<GetVehicleBrandsResponse>(
  VEHICLE_BRANDS_ENDPOINT,
  getVehicleBrandsRequestSchema,
);
